import Card from '../Card';
import gql from 'graphql-tag';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { useRegistrySummaryQuery, useWeddingWebsiteQuery } from '../../generated/graphql';
import { PageCardUIContext } from '../../PageCardUIContext';
import registryInfo from '../../helpers/registryInfo';
import CardContainer from '../CardContainer';
import { Page } from '../PageCard';
import PageHeader from '../PageCard/PageHeader';
import RegistryGuidanceCard from './RegistryGuidanceCard';
import { RegistryCardContent } from './RegistryCardContent';
import useIsLiteSite from '../../helpers/useIsLiteSite';
import { Link } from '@xo-union/tk-component-buttons';
import styles from './registryPageCard.scss';

interface Props {
  page: Page;
}

export const registrySummaryQuery = gql`
  query registrySummaryQuery {
    registrySummary {
      totalActiveGiftsRequested
      totalCashFunds
      totalGiftsReceived
      totalCashCentsReceived
      giftsByStore {
        name
      }
      hasTransactionalRegistry
      registries {
        isDeleted
        hiddenWws
        registryType
      }
    }
  }
`;

export const RegistryPageCard: React.FC<Props> = ({ page }) => {
  const { isPageOpenObj, togglePageOpen } = useContext(PageCardUIContext);
  const open = isPageOpenObj ? isPageOpenObj[page.id] : true;
  const { pathname } = useLocation();
  const { data, refetch: refetchRegistrySummary } = useRegistrySummaryQuery();
  const { data: weddingWebsiteData } = useWeddingWebsiteQuery();

  const { hasAnyRegistry } = registryInfo(data?.registrySummary);

  const preview = pathname.includes('preview');
  const isLiteSite = useIsLiteSite();

  return (
    <CardContainer
      data-testid="registry-page-card"
      className={hasAnyRegistry ? styles.registryCardContainer : styles.emptyRegistryCardContainer}
    >
      <Card>
        {hasAnyRegistry ? ( //when user has registry started
          <>
            {isLiteSite && preview ? (
              <Link href="/registry" size="md" color="secondary">
                Manage your registry
              </Link>
            ) : (
              <>
                {!preview && (
                  <PageHeader
                    page={page}
                    preview={preview}
                    toggleOpen={togglePageOpen && ((): void => togglePageOpen(page.id))}
                    open={open}
                  />
                )}
                {open ? (
                  <RegistryCardContent
                    onRegistryItemAdded={refetchRegistrySummary}
                    page={page}
                    preview={preview}
                    registrySummary={data?.registrySummary}
                    registryNote={weddingWebsiteData?.weddingWebsite.registryNote}
                  />
                ) : null}
              </>
            )}
          </>
        ) : (
          <RegistryGuidanceCard onRegistryItemAdded={refetchRegistrySummary} />
        )}
      </Card>
    </CardContainer>
  );
};
